import React from 'react';
import DispalyButton from '../images/DisplaySettingButton.svg'

const CardDisplayButton = () =>{

    return (
        <div>
            <img src={DispalyButton}></img>
        </div>
    )
}

export default CardDisplayButton